import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { getFirestore } from "@firebase/firestore";
import { app } from '../firebase.js';
import { collection, doc, orderBy, setDoc,query, getDocs, deleteDoc, where, updateDoc} from "@firebase/firestore"; 
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import defaulProfPic from '../Images/defprofile.png'
import MaskedPhone from '../Components/MaskedPhone';
import { logAdminActivity } from '../utils/activityLogger';

function GraduatedStudentComp() {
    const db = getFirestore(app);
    const auth = getAuth();
    let navigate = useNavigate();
  
    const [studentsList, setStudentList] = useState([]);
    const [countAllData, setcountAllData ] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterCourse, setFilterCourse] = useState('All');
    const [filterCountry, setFilterCountry] = useState('All');
    const [graduationRange, setGraduationRange] = useState('all');
    const [graduatedFrom, setGraduatedFrom] = useState('');
    const [graduatedTo, setGraduatedTo] = useState('');
    const lastSearchRef = useRef('');
    const lastCourseRef = useRef(filterCourse);
    const lastCountryRef = useRef(filterCountry);
    const lastRangeRef = useRef(graduationRange);
    const lastFromRef = useRef(graduatedFrom);
    const lastToRef = useRef(graduatedTo);
  
    useEffect(() => {
      const fetchData = async () => {
          const q = query(collection(db, 'users'), orderBy("appDate", 'desc'), where("userStatus", "==", "Completed"));
          const [querySnapshot, traineeSnapshot] = await Promise.all([
            getDocs(q),
            getDocs(collection(db, 'studentTrainees'))
          ]);
          const traineeMap = new Map();
          traineeSnapshot.forEach((traineeDoc) => {
            traineeMap.set(traineeDoc.id, traineeDoc.data());
          });
          const studentsItem = [];
          querySnapshot.forEach((doc) => {
              const studentData = doc.data();
              studentsItem.push({
                id: doc.id,
                ...studentData,
                studentTraineeRecord: traineeMap.get(studentData.userId || doc.id) || null
              });
          });
          studentsItem.sort((a, b) => {
            const aTime = getTimestampMillis(a.graduatedTime) || getTimestampMillis(a.appDate);
            const bTime = getTimestampMillis(b.graduatedTime) || getTimestampMillis(b.appDate);
            return bTime - aTime;
          });
          setStudentList(studentsItem);
          setcountAllData(studentsItem.length)
  
      };
  
      fetchData();
    }, []);

    useEffect(() => {
      const trimmed = searchTerm.trim();
      const timeoutId = setTimeout(() => {
        if (trimmed === lastSearchRef.current) return;
        lastSearchRef.current = trimmed;
        if (trimmed) {
          logAdminActivity({
            action: 'Search',
            details: `Graduated Students search: "${trimmed}"`,
            meta: { page: 'Graduated Students', query: trimmed }
          });
        }
      }, 600);
      return () => clearTimeout(timeoutId);
    }, [searchTerm]);

    useEffect(() => {
      if (filterCourse === lastCourseRef.current) return;
      lastCourseRef.current = filterCourse;
      logAdminActivity({
        action: 'Filter',
        details: `Graduated Students course filter: ${filterCourse}`,
        meta: { page: 'Graduated Students', filter: 'course', value: filterCourse }
      });
    }, [filterCourse]);

    useEffect(() => {
      if (filterCountry === lastCountryRef.current) return;
      lastCountryRef.current = filterCountry;
      logAdminActivity({
        action: 'Filter',
        details: `Graduated Students country filter: ${filterCountry}`,
        meta: { page: 'Graduated Students', filter: 'country', value: filterCountry }
      });
    }, [filterCountry]);

    useEffect(() => {
      if (graduationRange === lastRangeRef.current) return;
      lastRangeRef.current = graduationRange;
      logAdminActivity({
        action: 'Filter',
        details: `Graduated Students latest filter: ${graduationRange}`,
        meta: { page: 'Graduated Students', filter: 'graduationRange', value: graduationRange }
      });
    }, [graduationRange]);

    useEffect(() => {
      if (graduatedFrom === lastFromRef.current) return;
      lastFromRef.current = graduatedFrom;
      if (!graduatedFrom) return;
      logAdminActivity({
        action: 'Filter',
        details: `Graduated Students from date: ${graduatedFrom}`,
        meta: { page: 'Graduated Students', filter: 'graduatedFrom', value: graduatedFrom }
      });
    }, [graduatedFrom]);

    useEffect(() => {
      if (graduatedTo === lastToRef.current) return;
      lastToRef.current = graduatedTo;
      if (!graduatedTo) return;
      logAdminActivity({
        action: 'Filter',
        details: `Graduated Students to date: ${graduatedTo}`,
        meta: { page: 'Graduated Students', filter: 'graduatedTo', value: graduatedTo }
      });
    }, [graduatedTo]);
  
  
    function viewStudent(userId, studentName) {
      logAdminActivity({
        action: 'View Student',
        details: `Opened student profile: ${studentName || 'student'}`,
        meta: { page: 'Graduated Students', studentId: userId, studentName: studentName || '' }
      });
      navigate('/view-student', { state: { myData: userId } });
    }

    function getDateValue(value) {
      if (!value) return null;
      const dateObj = value.toDate ? value.toDate() : new Date(value);
      return Number.isNaN(dateObj.getTime()) ? null : dateObj;
    }

    function getTimestampMillis(value) {
      const dateObj = getDateValue(value);
      return dateObj ? dateObj.getTime() : 0;
    }

    function matchesLatestRange(graduationDate) {
      if (!graduationDate || graduationRange === 'all') return true;

      const today = new Date();
      const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      if (graduationRange === '7d') {
        const start = new Date(todayStart);
        start.setDate(start.getDate() - 7);
        return graduationDate >= start;
      }

      if (graduationRange === '30d') {
        const start = new Date(todayStart);
        start.setDate(start.getDate() - 30);
        return graduationDate >= start;
      }

      if (graduationRange === '90d') {
        const start = new Date(todayStart);
        start.setDate(start.getDate() - 90);
        return graduationDate >= start;
      }

      if (graduationRange === 'year') {
        return graduationDate.getFullYear() === today.getFullYear();
      }

      return true;
    }

    const uniqueCourses = Array.from(new Set(studentsList.map((student) => student.course).filter(Boolean))).sort();
    const uniqueCountries = Array.from(new Set(studentsList.map((student) => student.nationality).filter(Boolean))).sort();
    const filteredStudents = studentsList.filter((student) => {
      const search = searchTerm.trim().toLowerCase();
      const graduationDate = getDateValue(student.graduatedTime);
      const matchesSearch = !search || [
        student.bio,
        student.course,
        student.nationality,
        student.phoneNumber
      ].some((value) => String(value || '').toLowerCase().includes(search));

      const matchesCourse = filterCourse === 'All' || student.course === filterCourse;
      const matchesCountry = filterCountry === 'All' || student.nationality === filterCountry;
      const matchesRange = matchesLatestRange(graduationDate);

      let matchesFrom = true;
      if (graduatedFrom) {
        const fromDate = new Date(`${graduatedFrom}T00:00:00`);
        matchesFrom = graduationDate ? graduationDate >= fromDate : false;
      }

      let matchesTo = true;
      if (graduatedTo) {
        const toDate = new Date(`${graduatedTo}T23:59:59`);
        matchesTo = graduationDate ? graduationDate <= toDate : false;
      }

      return matchesSearch && matchesCourse && matchesCountry && matchesRange && matchesFrom && matchesTo;
    });

    const formatDateTime = (value) => {
      if (!value) return '—';
      const dateObj = value.toDate ? value.toDate() : new Date(value);
      if (Number.isNaN(dateObj.getTime())) return '—';
      const datePart = dateObj.toLocaleDateString();
      const timePart = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      return `${datePart} • ${timePart}`;
    };

    const totalCount = countAllData;
    const filteredCount = filteredStudents.length;
    const getTraineeLabel = (student) => student.studentTraineeRecord ? 'Onboarded' : 'Not onboarded';

    return (
      <div className="clientsComp applicationsPage">
        <div className="appsHeader">
          <div>
            <p className="appsKicker">Students</p>
            <h4>Graduated Students</h4>
            <p className="appsSubtext">Alumni who have successfully completed their programs, with filters for the latest graduation dates.</p>
          </div>
          <div className="appsHeaderStats">
            <div className="appsStatChip">
              <span>All</span>
              <strong>{totalCount}</strong>
            </div>
            <div className="appsStatChip">
              <span>Showing</span>
              <strong>{filteredCount}</strong>
            </div>
          </div>
        </div>

        <div className="appsFiltersCard">
          <div className="appsSearch input-group">
            <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
            <Form.Control
              type="text"
              placeholder="Search name, course, phone..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="appsFilterGroup">
            <Form.Select className="filterSelect" value={graduationRange} onChange={(e) => setGraduationRange(e.target.value)}>
              <option value="all">All Graduation Dates</option>
              <option value="7d">Latest 7 Days</option>
              <option value="30d">Latest 30 Days</option>
              <option value="90d">Latest 90 Days</option>
              <option value="year">This Year</option>
            </Form.Select>
            <Form.Select className="filterSelect" value={filterCourse} onChange={(e) => setFilterCourse(e.target.value)}>
              <option value="All">All Courses</option>
              {uniqueCourses.map((course) => (
                <option key={course} value={course}>{course}</option>
              ))}
            </Form.Select>
            <Form.Select className="filterSelect" value={filterCountry} onChange={(e) => setFilterCountry(e.target.value)}>
              <option value="All">All Countries</option>
              {uniqueCountries.map((country) => (
                <option key={country} value={country}>{country}</option>
              ))}
            </Form.Select>
            <Form.Control
              type="date"
              className="filterSelect"
              value={graduatedFrom}
              onChange={(e) => setGraduatedFrom(e.target.value)}
            />
            <Form.Control
              type="date"
              className="filterSelect"
              value={graduatedTo}
              onChange={(e) => setGraduatedTo(e.target.value)}
            />
          </div>
        </div>

        <div className="appsTableCard">
          <div className="appsTableHeader">
            <h6>Graduated Students</h6>
            <span>{filteredCount} results • newest graduation dates first</span>
          </div>
          <div className="appsTableWrap">
            <Table hover responsive className="appsTable">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Graduation Date</th>
                  <th>Application Date</th>
                  <th>Course</th>
                  <th>Country</th>
                  <th>Phone</th>
                  <th>Trainee</th>
                  <th>Cohort</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((mystudent) => (
                  <tr key={mystudent.id}>
                    <td>
                      <div className="appsStudentCell">
                        <div className='appDefProfPic'>
                          <img src={mystudent.profilePic ? mystudent.profilePic : defaulProfPic} alt="profile" />
                        </div>
                        <div>
                          <p className="appsStudentName">{mystudent.bio || 'Unnamed student'}</p>
                          <span className="appsStudentMeta">{mystudent.course || 'Course not set'}</span>
                        </div>
                      </div>
                    </td>
                    <td>{formatDateTime(mystudent.graduatedTime)}</td>
                    <td>{formatDateTime(mystudent.appDate)}</td>
                    <td>{mystudent.course || '—'}</td>
                    <td>{mystudent.nationality || '—'}</td>
                    <td>
                      <MaskedPhone
                        phoneNumber={mystudent.phoneNumber}
                        studentId={mystudent.userId}
                        studentName={mystudent.bio}
                      />
                    </td>
                    <td>
                      <span className={`studentFollowUpChip ${mystudent.studentTraineeRecord ? 'success' : 'muted'}`}>
                        {getTraineeLabel(mystudent)}
                      </span>
                    </td>
                    <td>{mystudent.cohort || '—'}</td>
                    <td>
                      <button className='appsViewBtn' onClick={() => viewStudent(mystudent.userId, mystudent.bio)}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredStudents.length === 0 && (
                  <tr>
                    <td colSpan="9" className="appsEmptyState">
                      No graduated students match your filters yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
  
    )
  }
  

export default GraduatedStudentComp
